module.exports = __webpack_public_path__ + "ae2973863e2606be7896aa1d8da0b1ae.jpg";